import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The knowledge document rich-content families' gates
 * (docs/plans/2026-10-06-feat-knowledge-document-rich-content-extensions-plan.md, "Rollout order
 * per Phase B family"), spread into FEATURE_GATE_SEEDS in feature-gate-registry.ts at their place
 * in its order. Each is a compatibility gate, not a sidebar item.
 */
export const DOCUMENT_FEATURE_GATE_SEEDS = {
  documents_tables: {
    label: 'Document tables',
    shortLabel: 'Tables',
    description:
      'Lets staff add tables to knowledge documents. Not a sidebar item - off means a document without a table cannot gain one; documents that already hold a table keep editing it, and every table still loads, exports and is read by Pulse AI.',
    group: 'pulse_ai',
  },
  documents_task_lists: {
    label: 'Document task lists',
    shortLabel: 'Task lists',
    description:
      'Lets staff add checklists to knowledge documents. Not a sidebar item - off means a document without a task list cannot gain one; documents that already hold one keep editing it, and every task list still loads, exports and is read by Pulse AI.',
    group: 'pulse_ai',
  },
  documents_mentions: {
    label: 'Document mentions',
    shortLabel: 'Mentions',
    description:
      'Lets staff mention a colleague with @ in knowledge documents. Not a sidebar item - off means a document without a mention cannot gain one; documents that already hold one keep editing them, and every mention still loads, exports and is read by Pulse AI. Mentions send no notification.',
    group: 'pulse_ai',
  },
  documents_task_links: {
    label: 'Document task links',
    shortLabel: 'Task links',
    description:
      'Lets staff turn checklist items in knowledge documents into tasks. Not a sidebar item - off means no new conversions; items already linked keep their task, and every document still loads, exports and is read by Pulse AI.',
    group: 'pulse_ai',
  },
  documents_text_style: {
    label: 'Document text style',
    shortLabel: 'Text style',
    description:
      'Lets staff set the font, text size, line spacing, subscript and superscript in knowledge documents. Not a sidebar item - off means a document without any of these cannot gain them; documents that already hold one keep full use of all of them, and styled text still loads, exports and is read by Pulse AI.',
    group: 'pulse_ai',
  },
} satisfies Record<string, FeatureGateSeed>;
